import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, value, icon, trend, trendValue, variant = 'default' }) => {
  const variantStyles = {
    default: 'bg-card border-border',
    primary: 'bg-primary/10 border-primary/20',
    success: 'bg-success/10 border-success/20',
    warning: 'bg-warning/10 border-warning/20'
  };

  const iconColors = {
    default: 'var(--color-text-secondary)',
    primary: 'var(--color-primary)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)'
  };

  return (
    <div className={`${variantStyles?.[variant]} border rounded-lg p-6 transition-all duration-150 hover:shadow-md`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-text-secondary mb-1">{title}</p>
          <p className="text-3xl font-semibold text-text-primary">{value}</p>
          {trend && (
            <div className="flex items-center gap-1 mt-2">
              <Icon 
                name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} 
                size={14} 
                color={trend === 'up' ? 'var(--color-success)' : 'var(--color-error)'} 
              />
              <span className={`text-xs font-medium ${trend === 'up' ? 'text-success' : 'text-error'}`}>
                {trendValue}
              </span>
              <span className="text-xs text-text-secondary ml-1">vs last month</span>
            </div>
          )}
        </div>
        <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${variant === 'default' ? 'bg-muted' : 'bg-white/50'}`}>
          <Icon name={icon} size={24} color={iconColors?.[variant]} />
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;